export function getFlagIcon(lang) {
  if (lang === 'en') {
    return 'fi fi-gb';
  }

  return `fi fi-${lang}`;
}
